module.exports = "/images/Generic House.svg?ba91a5bdf3e96b40d54199ec1e9fdb64";